/* ===================================================
   ME knit -- App JavaScript (Shopify Theme)
   Scroll reveal, menu toggle, carousel, price slider
   =================================================== */

(function () {
  'use strict';

  // -- Scroll Reveal --
  function initScrollReveal() {
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    reveals.forEach(function (el) { observer.observe(el); });
  }

  // -- Header Shadow on Scroll --
  function initHeaderShadow() {
    var header = document.getElementById('header');
    if (!header) return;

    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // -- Hamburger Menu --
  function initMenu() {
    var btn = document.getElementById('hamburger-btn');
    var overlay = document.getElementById('menu-overlay');
    var closeBtn = document.getElementById('menu-close');
    if (!btn || !overlay) return;

    function openMenu() {
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      btn.classList.add('active');
    }

    function closeMenu() {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
      btn.classList.remove('active');
    }

    btn.addEventListener('click', function () {
      if (overlay.classList.contains('open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeMenu();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('open')) {
        closeMenu();
      }
    });
  }

  // -- Expandable "Pood" in hamburger menu --
  function initExpandableMenu() {
    var parents = document.querySelectorAll('.menu-overlay__link--parent');
    parents.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        btn.closest('.menu-overlay__expandable').classList.toggle('open');
      });
    });
  }

  // -- Price Range Slider --
  function initPriceSlider() {
    var minInput = document.getElementById('price-min');
    var maxInput = document.getElementById('price-max');
    var minLabel = document.getElementById('price-min-label');
    var maxLabel = document.getElementById('price-max-label');
    if (!minInput || !maxInput) return;

    function updateLabels() {
      var minVal = parseInt(minInput.value, 10);
      var maxVal = parseInt(maxInput.value, 10);
      if (minVal > maxVal) {
        var temp = minVal;
        minVal = maxVal;
        maxVal = temp;
      }
      if (minLabel) minLabel.textContent = '\u20AC' + minVal;
      if (maxLabel) maxLabel.textContent = '\u20AC' + maxVal;
    }

    minInput.addEventListener('input', updateLabels);
    maxInput.addEventListener('input', updateLabels);
  }

  // -- Featured Products Carousel --
  function initCarousel() {
    var grid = document.getElementById('featured-grid');
    var prevBtn = document.getElementById('carousel-prev');
    var nextBtn = document.getElementById('carousel-next');
    if (!grid || !prevBtn || !nextBtn) return;

    function getScrollAmount() {
      var card = grid.querySelector('.product-card');
      if (!card) return 200;
      var style = window.getComputedStyle(grid);
      var gap = parseFloat(style.columnGap) || 16;
      return (card.offsetWidth + gap) * 2;
    }

    function updateButtons() {
      prevBtn.disabled = grid.scrollLeft <= 5;
      nextBtn.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 5;
    }

    prevBtn.addEventListener('click', function () {
      grid.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      grid.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    grid.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    setTimeout(updateButtons, 100);
  }

  // -- Product Gallery Swap --
  function initProductGallery() {
    var mainImage = document.getElementById('MainProductImage');
    var thumbs = document.querySelectorAll('.product-layout__thumb');
    
    if (!mainImage || !thumbs.length) return;
    
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var fullSrc = thumb.getAttribute('data-full-src') || thumb.src;
        mainImage.src = fullSrc;
        
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  // -- Initialize Everything --
  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    initHeaderShadow();
    initMenu();
    initExpandableMenu();
    initPriceSlider();
    initCarousel();
    initProductGallery();
  });
})();
